export const scratchInstructions = [
  {
    type: 'standard',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>PayPal Checkout HTML/JavaScript with NodeJS</h3>
        <h4>HTML</h4>
        <ol>
          <li>Create a folder named client.</li>
          <li>
            Inside of the client folder create two files: <strong>checkout.html</strong> and <strong>app.js</strong>. Copy paste the provided code snippets for these files.
            <ul>
              <strong>Optional:</strong> Customize your code.
            </ul>
          </li>
          <li>In the checkout.html file, replace <strong>test</strong> client ID in the SDK <strong>script</strong> tag with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
        </ol>
        <h4>NodeJS</h4> 
        <ol> 
          <li>Create a folder named <strong>server</strong>.</li>
          <li>Create a file named <strong>server.js</strong>. Copy paste the code provided in the code snippets for this file.</li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>Create a <strong>package.json</strong> file. Copy paste the contents of this sample <a href='https://github.com/paypaldev/PayPal-JavaScript-FullStack-Standard-Checkout-Sample/blob/main/package.json'>package.json</a> file into your own <strong>package.json</strong> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
              <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
              <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
              <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>PayPal Checkout React with NodeJS</h3>
        <h4>React</h4>
        <ol>
          <li>Use a tool like Create-React-App or Vite to manage the local development workflow for your React code. When building it for prod, deploy it to a static folder and have your Node.js web server serve up that static directory. </li>
          <li>Create a React application inside a folder called <strong>client</strong> with an <strong>App.jsx</strong> file and copy paste the code snippets that correspond to this file. </li>
          <li>Optional: Customize your code. </li>
          <li>Inside your <strong>App.jsx</strong> file, locate the initialOptions object, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>. </li>
        </ol>
        <h4>NodeJS</h4>
        <ol>
          <li>Create a folder called server and create a <strong>server.js</strong> file and copy paste the code snippets that correspond to this file.  </li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In the <strong>package.json</strong> file, replace the content with the content of this sample <a href='https://github.com/paypaldev/PayPal-React-FullStack-Standard-Checkout-Sample/blob/main/package.json'>package.json</a> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
              <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
              <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
              <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
              <a href='https://www.npmjs.com/package/@paypal/react-paypal-js'><li>PayPal React</li></a>
              <a href='https://www.npmjs.com/package/concurrently'><li>Concurrently</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
        </ol>
        <h4>Run this project</h4>
        <ol>
            <li>In the project root, run the project by running <strong>npm start</strong> in your terminal.</li>
            <li>Navigate to http://localhost:3000/ and view the application. </li>
        </ol>
        `,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>Expanded Checkout HTML/JavaScript with NodeJS</h3>
        <h4>HTML</h4>
        <ol>
          <li>Create a folder named client.</li>
          <li>
            Inside of the client folder create a file called <strong>app.js</strong>. Copy paste the provided code snippets for this file.
          </li>
        </ol>
        <h4>NodeJS</h4> 
        <ol> 
          <li>In the root of your project create two folders called server and views.</li>
          <li>Inside of the views folder create a file called checkout.ejs. and copy paste the code from the respective code snippet into this file. </li>
          <li>Inside the backend folder create a file called server.js. and copy paste the code from the respective code snippet into this file</li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>Create a <strong>package.json</strong> file in the root of your project. Copy paste the contents of this sample <a href='https://github.com/paypaldev/PayPal-JavaScript-FullStack-Standard-Checkout-Sample/blob/main/package.json'>package.json</a> file into your own <strong>package.json</strong> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
                <a href='https://www.npmjs.com/package/ejs'><li>EJS</li></a>
                <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
                <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
                <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'payment-buttons_3ds',
    instructions: `<h3>Expanded Checkout 3Ds HTML/JavaScript with NodeJS</h3>
        <h4>HTML</h4>
        <ol>
          <li>Create a folder named client.</li>
          <li>
            Inside of the client folder create a file called <strong>app.js</strong>. Copy paste the provided code snippets for this file.
          </li>
        </ol>
        <h4>NodeJS</h4> 
        <ol> 
          <li>In the root of your project create two folders called server and views.</li>
          <li>Inside of the views folder create a file called checkout.ejs. and copy paste the code from the respective code snippet into this file. </li>
          <li>Inside the backend folder create a file called server.js. and copy paste the code from the respective code snippet into this file</li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>Create a <strong>package.json</strong> file in the root of your project. Copy paste the contents of this sample <a href='https://github.com/paypaldev/PayPal-JavaScript-FullStack-3Ds-Advanced-Checkout-Sample/blob/main/package.json'>package.json</a> file into your own <strong>package.json</strong> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
                <a href='https://www.npmjs.com/package/ejs'><li>EJS</li></a>
                <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
                <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
                <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>Expanded Checkout React with NodeJS</h3>
        <h4>React</h4>
        <ol>
          <li>Use a tool like Create-React-App or Vite to manage the local development workflow for your React code. When building it for prod, deploy it to a static folder and have your Node.js web server serve up that static directory. </li>
          <li>Create a React application inside a folder called <strong>client</strong> with an <strong>App.jsx</strong> and <strong>PaymentForm.jsx</strong> files and copy paste the code snippets that correspond to these file. </li>
          <li>Create a <strong>PaymentForm.module.css</strong> file and copy paste the code snippets that correspond to this file.</li>
          <li>Optional: Customize your code. </li>
          <li>Inside your <strong>App.jsx</strong> file, locate the initialOptions object, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>. </li>
        </ol>
        <h4>NodeJS</h4>
        <ol>
          <li>Create a folder called server and create a <strong>server.js</strong> file and copy paste the code snippets that correspond to this file.  </li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In the <strong>package.json</strong> file, replace the content with the content of this sample <a href='https://github.com/paypaldev/PayPal-React-FullStack-Standard-Checkout-Sample/blob/main/package.json'>package.json</a> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
              <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
              <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
              <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
              <a href='https://www.npmjs.com/package/@paypal/react-paypal-js'><li>PayPal React</li></a>
              <a href='https://www.npmjs.com/package/concurrently'><li>Concurrently</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
        </ol>
        <h4>Run this project</h4>
        <ol>
            <li>In the project root, run the project by running <strong>npm start</strong> in your terminal.</li>
            <li>Navigate to http://localhost:3000/ and view the application. </li>
        </ol>    
        `,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'recurring',
    threeDs: 'no_3ds',
    instructions: `<h3>Subscriptions with HTML/JavaScript with NodeJS</h3>
        <h4>HTML</h4>
        <ol>
          <li>Create a folder named client.</li>
          <li>
            Inside of the client folder create two files: <strong>checkout.html</strong> and <strong>app.js</strong>. Copy paste the provided code snippets for these files.
            <ul>
              <strong>Optional:</strong> Customize your code.
            </ul>
          </li>
          <li>In the checkout.html file, replace <strong>test</strong> client ID in the SDK <strong>script</strong> tag with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
        </ol>
        <h4>NodeJS</h4> 
        <ol> 
          <li>Create a folder named <strong>server</strong>.</li>
          <li>Create a file named <strong>server.js</strong>. Copy paste the code provided in the code snippets for this file.</li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>Create a <strong>package.json</strong> file. Copy paste the contents of this sample <a href='https://github.com/paypaldev/PayPal-JavaScript-Subscription-Sample/blob/main/package.json'>package.json</a> file into your own <strong>package.json</strong> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
              <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
              <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
              <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'recurring',
    threeDs: 'no_3ds',
    instructions: `<h3>Subscriptions with React with NodeJS</h3>
        <h4>React</h4>
        <ol>
          <li>Use a tool like Create-React-App or Vite to manage the local development workflow for your React code. When building it for prod, deploy it to a static folder and have your Node.js web server serve up that static directory. </li>
          <li>Create a React application inside a folder called <strong>client</strong> with an <strong>App.jsx</strong> file and copy paste the code snippets that correspond to this file. </li>
          <li>Optional: Customize your code. </li>
          <li>Inside your <strong>App.jsx</strong> file, locate the initialOptions object, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>. </li>
        </ol>
        <h4>NodeJS</h4>
        <ol>
          <li>Create a folder called server and create a <strong>server.js</strong> file and copy paste the code snippets that correspond to this file.  </li>
          <li>Create a <strong>.env</strong> file and pass the following variables:</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In the <strong>package.json</strong> file, replace the content with the content of this sample <a href='https://github.com/paypaldev/PayPal-React-Subscription-Sample/blob/main/package.json'>package.json</a> file. This file defines the dependencies used inside the <strong>server.js</strong> file. The dependencies needed are:</li>
            <ul>
              <a href='https://www.npmjs.com/package/dotenv'><li>Dotenv</li></a>
              <a href='https://www.npmjs.com/package/express'><li>Express</li></a>
              <a href='https://www.npmjs.com/package/node-fetch'><li>Node-fetch</li></a>
              <a href='https://www.npmjs.com/package/@paypal/react-paypal-js'><li>PayPal React</li></a>
              <a href='https://www.npmjs.com/package/concurrently'><li>Concurrently</li></a>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
        </ol>
        <h4>Run this project</h4>
        <ol>
            <li>In the project root, run the project by running <strong>npm start</strong> in your terminal.</li>
            <li>Navigate to http://localhost:3000/ and view the application. </li>
        </ol>
        `,
  },
]

export const cloneInstructions = [
  {
    type: 'standard',
    mode: 'cloned',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>PayPal Checkout HTML/JavaScript with NodeJS</h3>
        <ol>
          <li>Clone the existing HTML and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-JavaScript-FullStack-Standard-Checkout-Sample/tree/main">Github repo.</a> </li>
          <li>Optional:</strong> Customize your code.</li>
          <li>In the checkout.html file, replace <strong>test</strong> client ID in the SDK <strong>script</strong> tag with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
          <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>PayPal Checkout React with NodeJS</h3>
        <ol>
          <li>Clone the existing React and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-React-FullStack-Standard-Checkout-Sample/tree/main">Github repo.</a> </li>
          <li>Optional:</strong> Customize your code.</li>
          <li>Inside your src folder of the React app find the <stong>App.jsx</strong> file, locate the initialOptions object inside of this file, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
          <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install all the project dependencies of the React and NodeJS app, including the <a href="https://www.npmjs.com/package/@paypal/react-paypal-js">PayPal React NPM package</a>. </li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:3000/'>http://localhost:3000/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>Expanded Checkout HTML/JavaScript with NodeJS</h3>
    <ol>
      <li>Clone the existing HTML and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-JavaScript-FullStack-Advanced-Checkout-Sample">Github repo.</a> </li>
      <li>Optional:</strong> Customize your code.</li>
      <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
        <ul>
          <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
          <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
          <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
        </ul>
      <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
      <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
      <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
    </ol>`,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'onetime-payment',
    threeDs: 'no_3ds',
    instructions: `<h3>Expanded Checkout React with NodeJS</h3>
        <ol>
          <li>Clone the existing React and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-React-FullStack-Advanced-Checkout-Sample">Github repo.</a> </li>
          <li>Optional:</strong> Customize your code.</li>
          <li>Inside your src folder of the React app find the <stong>App.jsx</strong> file, locate the initialOptions object inside of this file, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
          <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install all the project dependencies of the React and NodeJS app, including the <a href="https://www.npmjs.com/package/@paypal/react-paypal-js">PayPal React NPM package</a>. </li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:3000/'>http://localhost:3000/</a> to view the application.</li>
        </ol>`,
  },
  {
    type: 'advanced',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'onetime-payment',
    threeDs: 'payment-buttons_3ds',
    instructions: `<h3>Expanded Checkout 3Ds HTML/JavaScript with NodeJS</h3>
    <ol>
      <li>Clone the existing HTML and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-JavaScript-FullStack-3Ds-Advanced-Checkout-Sample">Github repo.</a> </li>
      <li>Optional:</strong> Customize your code.</li>
      <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
        <ul>
          <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
          <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
          <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
        </ul>
      <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
      <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
      <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
    </ol>`,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'html',
    paymentModel: 'recurring',
    threeDs: 'no_3ds',
    instructions: `<h3>Subscription with HTML/JavaScript with NodeJS</h3>
    <ol>
      <li>Clone the existing HTML and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-JavaScript-Subscription-Sample">Github repo.</a> </li>
      <li>Optional:</strong> Customize your code.</li>
      <li>In the checkout.html file, replace <strong>test</strong> client ID in the SDK <strong>script</strong> tag with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
      <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
        <ul>
          <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
          <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
          <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
        </ul>
      <li>In your terminal, run <strong>npm install</strong> to install the project dependencies.</li>
      <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
      <li>Navigate to <a href='http://localhost:8888/'>http://localhost:8888/</a> to view the application.</li>
    </ol>`,
  },
  {
    type: 'standard',
    mode: 'scratch',
    language: 'react',
    paymentModel: 'recurring',
    threeDs: 'no_3ds',
    instructions: `
        <h3>Subscriptions React with NodeJS</h3>
        <ol>
          <li>Clone the existing React and NodeJS combination from the <a href="https://github.com/paypaldev/PayPal-React-Subscription-Sample">Github repo.</a> </li>
          <li>Optional:</strong> Customize your code.</li>
          <li>Inside your src folder of the React app find the <stong>App.jsx</strong> file, locate the initialOptions object inside of this file, and replace <strong>PAYPAL_CLIENT_ID</strong> with your own sandbox Business Account app client ID. These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
          <li>Rename the <strong>.env.example</strong> file to <strong>.env</strong> and pass the following variables</li>
            <ul>
              <li><strong>PAYPAL_CLIENT_ID=YOUR_CLIENT_ID</strong></li>
              <li><strong>PAYPAL_CLIENT_SECRET=YOUR_APP_SECRET</strong></li>
              <li>These credentials are available in the <a href="https://developer.paypal.com/dashboard/">Developer Dashboard</a>.</li>
            </ul>
          <li>In your terminal, run <strong>npm install</strong> to install all the project dependencies of the React and NodeJS app, including the <a href="https://www.npmjs.com/package/@paypal/react-paypal-js">PayPal React NPM package</a>. </li>
          <li>Run the project by running <strong>npm start</strong> in your terminal.</li>
          <li>Navigate to <a href='http://localhost:3000/'>http://localhost:3000/</a> to view the application.</li>
        </ol>
        `,
  },
]
